
import { getCurrentInstance, ref } from 'vue'
import CrmAuthConnectLayout from '@/components/connectors/shared/CrmAuthConnectLayout.vue'
import { useCrmAuthWizardNav } from '@/components/connectors/shared/useCrmAuthWizardNav.js'

const INSTRUCTION_URL =
    'http://help.dataheroes.pro/?slug=1327-podklyuchenie-dikidi-novoe'

export default {
    name: 'DikidiAuthSimple',
    components: { CrmAuthConnectLayout },
    setup() {
        const root = getCurrentInstance()!.proxy as any
        const store = root.$store
        const loading = ref(false)

        const goBackToCrm = () => {
            root.$parent.$emit('goBackToCrm')
        }

        const removeProject = async () => {
            loading.value = true
            syncWizardNav()
            try {
                await store.dispatch(
                    'project/deleteProject',
                    root.$router.currentRoute.params.id
                )
                await root.$router.push(`/projects`)
            } finally {
                loading.value = false
                syncWizardNav()
            }
        }

        const onInstructionClick = () => {
            // Legacy AuthSimple: opening the help link abandons the empty onboarding project
            removeProject()
        }

        const goNext = async () => {
            await removeProject()
        }

        const { hasWizardNav, syncWizardNav } = useCrmAuthWizardNav(
            () => ({
                canBack: true,
                canNext: true,
                nextLoading: loading.value,
                nextLabel: 'К моим проектам',
                onBack: goBackToCrm,
                onNext: goNext,
            }),
            [loading]
        )

        return {
            instructionUrl: INSTRUCTION_URL,
            loading,
            hasWizardNav,
            goBackToCrm,
            goNext,
            onInstructionClick,
        }
    },
}
